<template>
    <div
    v-if="!animateMe"
    class="mobile-bottom-entries-features-wrapper"
    @scroll="valueScrolled = $event.target.scrollTop">
        <!-- Navigation-header-base -->
        <navigation-header-base
        hideTabs
        hideClose
        isMobileBottomFeatureWrapper
        :showSearchSlot="showSearchSlot"
        :customBreadcrumbs="customBreadcrumbs"
        :hideBreadcrumbs="!hideBreadcrumbsButShowOnCurtain"
        :hideBreadcrumbsButShowOnCurtain="hideBreadcrumbsButShowOnCurtain"
        :valueScrolled="valueScrolled">
            <!-- Feature Header -->
            <template #top-mobile-header-slot>
                <navigation-header-menu
                :showSearchOnHeaderMenu="showSearchOnHeaderMenu"
                :showWelcomeMessage="showWelcomeMessage"/>
            </template>
            <!-- Slot for search -->
            <template v-if="showSearchSlot" #top-search-area-slot><slot name="top-search-area-slot"/></template>
        </navigation-header-base>

        <!-- Feature Content -->
        <div
        class="mobile-bottom-entries-feature-content-container"
        :class="{'third-level-menu': thirdLevelMenu, 'apply-particular-home-background-color': applyParticularHomeBackgroundColor}">
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
import NavigationHeaderBase from '@/components/generic/navigation/header/Base'
import NavigationHeaderMenu from '@/components/generic/navigation/header/Menu'
/* Vue */
import { ref, onMounted } from 'vue'

const valueScrolled = ref(0)

/* Emmitters */
const emit = defineEmits(['applyLoginLoaderExitAnimation'])

/** props received
@animateEntry { Boolean } prop to animate view entry
@showWelcomeMessage { Boolean } prop to show welcome message
@showSearchOnHeaderMenu { Boolean } prop to show search on header menu
@applyParticularHomeBackgroundColor { Boolean } prop to apply home gradient background
@hideBreadcrumbsButShowOnCurtain {Boolean}
@customBreadcrumbs {Object}
@showSearchSlot {Boolean}
@thirdLevelMenu {Boolean}
*/
const props = defineProps({
    animateEntry: Boolean,
    showWelcomeMessage: Boolean,
    showSearchOnHeaderMenu: Boolean,
    applyParticularHomeBackgroundColor: Boolean,
    hideBreadcrumbsButShowOnCurtain: Boolean,
    customBreadcrumbs: Object,
    showSearchSlot: Boolean,
    thirdLevelMenu: Boolean
})

const animateMe = ref(props.animateEntry)

onMounted(() => {
    animateMe.value = false
    setTimeout(() => {
        emit('applyLoginLoaderExitAnimation')
    })
})
</script>

<style lang="scss" scoped>
.mobile-bottom-entries-features-wrapper {
    width: 100%;
    height: 100%;

	padding-bottom: calc(16px + constant(safe-area-inset-bottom)); /* iOS 11.0 */
	padding-bottom: calc(16px + env(safe-area-inset-bottom)); /* iOS 11.2 */

    display: flex;
    flex-direction: column;

    z-index: 1;

    overflow: auto;
    overflow-x: hidden;
    position: relative;

    .header-placeholder {
        width: 100%;
        height: 80px;

        padding-left: 24px;
        line-height: 64px;

        flex-shrink: 0;
    }

    .mobile-bottom-entries-feature-content-container {
        width: 100%;
        height: auto;
        flex: 1;

        background-color: var(--secondary-light-4);
        border-radius: 16px 16px 0 0;
        z-index: 1;

        &.third-level-menu {
            background-color: var(--secondary-light-3);
        }

        &.apply-particular-home-background-color {
            background-color: var(--gradient-horizontal);
        }
    }

}
</style>
